/* src/app/components/billing/reports/activity-report/activity-report.component.css */
nz-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 15px;
}
nz-checkbox-group nz-checkbox {
  display: flex;
  align-items: center;
  margin-right: 0;
}
nz-checkbox-group nz-checkbox span:last-child {
  margin-left: 5px;
}
.report-container {
  display: flex;
  margin: 16px;
  width: 100%;
}
.report-label {
  margin-bottom: 4px;
  font-weight: 600;
}
.header-bg {
  background-color: #a8e4e14d;
}
.radio-group-container {
  display: flex;
  flex-direction: column;
}
.radio-label {
  font-weight: 500;
  margin-bottom: 5px;
}
.chart-wrapper {
  width: 60%;
}
@media (max-width: 768px) {
  .chart-wrapper {
    width: 100%;
  }
}
/*# sourceMappingURL=activity-report.component-GDRFYUIL.css.map */
